import { QuestionType } from "api/landlord-surveys/types/questions";
import { DraftSurveyTemplateQuestion } from "../../types";

export const ACTION_OPTIONS = [
  { label: "Hide", value: "hide" },
  { label: "End survey", value: "end_survey" }
];

const CONDITION_TYPE_FILLED = [
  { label: "Filled in", value: "filled_in" },
  { label: "Empty", value: "empty" }
];

const CONDITION_TYPE_SELECTED = [{ label: "Selected", value: "selected" }];

/** Question types that use "Selected" + answer value */
const OPTION_QUESTION_TYPES: ReadonlySet<QuestionType> = new Set([
  QuestionType.YES_NO,
  QuestionType.RADIO_GROUP,
  QuestionType.CHECKBOX_MULTI
]);

/** Question types that use "Filled in" / "Empty" (no answer value) */
export const FIELD_QUESTION_TYPES: ReadonlySet<QuestionType> = new Set([
  QuestionType.LONG_TEXT,
  QuestionType.DATE,
  QuestionType.FILE_SINGLE,
  QuestionType.ADDRESS
]);

export const getConditionTypeOptions = (
  question: DraftSurveyTemplateQuestion | undefined
) => {
  if (!question) return CONDITION_TYPE_SELECTED;
  if (FIELD_QUESTION_TYPES.has(question.type)) return CONDITION_TYPE_FILLED;
  return CONDITION_TYPE_SELECTED;
};

export const getAnswerOptions = (
  question: DraftSurveyTemplateQuestion | undefined
) => {
  if (!question) return [];
  if (!("options" in question) || !question.options) return [];
  return question.options.map((opt) => ({
    label: opt.value,
    value: opt.value
  }));
};

const LABEL_MAP: Partial<Record<string, string>> = {
  hide: "Hide",
  end_survey: "End survey",
  filled_in: "Filled in",
  empty: "Empty",
  selected: "Selected"
};

export const toLabel = (value: string) => LABEL_MAP[value] ?? value;

export const hasAnswerSelection = (
  question: DraftSurveyTemplateQuestion | undefined
) => (question ? OPTION_QUESTION_TYPES.has(question.type) : false);
